export default __webpack_public_path__ + "static/media/DN.2c9c3276.svg";